import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { Menu, Icon } from 'semantic-ui-react';

function Navigation() {
  const location = useLocation();
  const currentPath = location.pathname.split('/').pop() || 'dashboard';

  const navItems = [
    { name: 'dashboard', label: 'Dashboard', icon: 'dashboard' },
    { name: 'tasks', label: 'All Tasks', icon: 'list' },
    { name: 'create', label: 'Create Task', icon: 'plus circle' },
    { name: 'history', label: 'History', icon: 'history' },
    { name: 'metrics', label: 'Metrics', icon: 'chart bar' },
    { name: 'meetings', label: 'Meetings', icon: 'calendar' },
  ];

  return (
    <NavWrapper>
      <Menu pointing secondary>
        {navItems.map((item) => (
          <Menu.Item
            key={item.name}
            as={Link}
            to={`/app/slack-tasks/${item.name}`}
            active={currentPath === item.name}
          >
            <Icon name={item.icon} />
            {item.label}
          </Menu.Item>
        ))}
      </Menu>
    </NavWrapper>
  );
}

const NavWrapper = styled.div`
  margin-bottom: 20px;
  
  .ui.menu {
    border-bottom: 2px solid #e0e0e0;
    
    .item {
      font-weight: 500;
      
      &.active {
        border-color: #2185d0;
        color: #2185d0;
      }
      
      i.icon {
        margin-right: 8px;
      }
    }
  }
`;

export default Navigation;
